import React from 'react';
import { Anchor } from 'elements';
import momentDate from 'utils/momentDate';
import tulkojumi from 'utils/tulkojumi';
import { MetaWrapper, StyledMetaList } from './styled';

const MetaList = (props) => {
  const {
    postType,
    dateCreated,
    dateModified,
    teksti,
    lang,
    acf,
  } = props;

  let acfObject;
  if (typeof acf === 'string') {
    try {
      acfObject = JSON.parse(acf);
    } catch (error) { }
  } else {
    acfObject = Object.assign({}, acf);
  }

  let metaKeys = [];
  if (postType === 'dokumenti') {
    metaKeys = [
      'iestade_nosaukums',
      'publicets',
      'atjaunots',
    ];
  } else if (postType === 'iepirkumi') {
    metaKeys = [
      'iepirkuma_statuss',
      'publicesanas_datums',
      'iesnieguma_termins',
      'lemuma_datums',
      'atjaunots',
    ];
  } else if (postType === 'projekti') {
    metaKeys = [
      'iesniedzejs',
      'publicets',
      'atjaunots',
    ];
  } else if (postType === 'nodoklu_zinojumi') {
    metaKeys = [
      'publicets',
      'izdots',
    ];
  // NOTE: Noradīts ar roku, kodā – default
  } else {
    metaKeys = [
      'post_tag',
      'publicets',
      'atjaunots',
    ];
  }

  const getMetaLabel = (key) => {
    if (key === 'izdots') {
      return tulkojumi(teksti, 'izdosanas_datums');
    } else if (key === 'iestade_nosaukums') {
      return tulkojumi(teksti, 'iestade');
    } else if (key === 'iepirkuma_statuss') {
      return tulkojumi(teksti, 'iepirkuma_statuss');
    } else if (key === 'iesnieguma_termins') {
      return tulkojumi(teksti, 'iesniegsanas_termins');
    } else if (key === 'iesniedzejs') {
      return tulkojumi(teksti, 'iesniedzejs');
    } else if (key === 'post_tag') {
      return tulkojumi(teksti, 'tema');
    } else if (key === 'publicesanas_datums' || key === 'publicets' || key === 'date_created') {
      return tulkojumi(teksti, 'publicets');
    } else if (key === 'atjaunots' || key === 'date_modified') {
      return tulkojumi(teksti, 'atjaunots');
    } else if (key === 'lemuma_datums') {
      return tulkojumi(teksti, 'lemuma_datums');
    }
    return tulkojumi(teksti, key);
  };

  const getMetaField = (key) => {
    const field = acfObject[key];

    // Iestāde
    if (key === 'iestade_nosaukums') {
      return acfObject.iestade_saite ? (
        <Anchor href={acfObject.iestade_saite}>
          {field}
        </Anchor>
      ) : field;
    // Datumi
    } else if (
      key === 'publicesanas_datums' ||
      key === 'iesnieguma_termins' ||
      key === 'lemuma_datums' ||
      key === 'izdots' ||
      key === 'publicets' ||
      key === 'atjaunots' ||
      key === 'date_created' ||
      key === 'date_modified'
    ) {
      const date = field && field;
      return date && momentDate(
        parseInt(date, 10), lang
      );
    // Teksts
    } else {
      return field;
    }
  };

  const metaLabels = metaKeys.map((key, i) => {
    const field = getMetaField(key);
    return field && (
      <li key={i}>
        {`${getMetaLabel(key)}: `}
      </li>
    );
  })
  .filter(meta => meta && meta);

  const metaContents = metaKeys.map((key, i) => {
    const field = getMetaField(key);
    return field && (
      <li key={i}>
        {field}
      </li>
    )
  })
  .filter(meta => meta && meta);

  return (
    <MetaWrapper>
      {
        metaLabels && metaLabels.length > 0 && (
          <StyledMetaList>
            {metaLabels}
          </StyledMetaList>
        )
      }

      {
        metaContents && metaContents.length > 0 && (
          <StyledMetaList>
            {metaContents}
          </StyledMetaList>
        )
      }
    </MetaWrapper>
  );
};

export default MetaList;



// WEBPACK FOOTER //
// ./src/modules/MetaList/MetaList.jsx